import { DEFAULT_LANGUAGE } from '@/config/constants'
import { SOURCE } from '@/config/events'

let _referrer

export function getRouteData(options) {
  const { origin, search } = window.location
  const params = new URLSearchParams(search)
  const language = params.get('language') || DEFAULT_LANGUAGE
  const title = options.title
  const subRoutes = options.routes || []

  const url = [origin, ...subRoutes].join('/')

  let referrerUrl = document.referrer
  if (_referrer) {
    referrerUrl = _referrer.page.url
  }

  const description = [SOURCE.PARTNER_WIDGET, language.toUpperCase(), title].join(' - ')
  const descriptionWithoutLang = [SOURCE.PARTNER_WIDGET, title].join(' - ')

  // Get page and route data
  const data = {
    page: {
      title,
      description,
      descriptionWithoutLang,
      language,
      url,
      aliasUrl: url,
      referrerUrl,
    },
  }
  _referrer = { ...data }
  return data
}

export function getPackageTrackingId(pwPackage) {
  if (!pwPackage) {
    console.error('Can not get tracking id, pwPackage was falsy')
    return ''
  }
  const packageId = pwPackage.id
  if (!packageId || packageId.split('-', 1).length === 0) {
    console.error('Could not extract tracking id')
    return ''
  }
  return 'package-' + packageId.split('-', 1)[0]
}
